import { Link } from "gatsby";
import React from "react";

import { Buttons, Container, Logo, StyledLink } from "./styles";

// export const changeTheme = (theme) => {
//   return {
//     type: "CHANGETHEME",
//     theme,
//   };
// };

const Header = ({ siteTitle }) => {
  // const dispatch = useDispatch();
  // const darkQuery = window.matchMedia("(prefers-color-scheme: dark)");
  // darkQuery.addListener((e) => {
  //   dispatch(changeTheme(e.matches ? "dark" : "light"));
  // });
  const content = { message: "", login: true };
  return (
    <Container>
      <Logo>
        <Link className="logo" to="/">
          {siteTitle}
        </Link>
      </Logo>

      <span>{content.message}</span>
      <Buttons>
        <StyledLink to="/post" activeClassName="active" partiallyActive={true}>
          블로그
        </StyledLink>
        <StyledLink
          to="/ai-archive"
          activeClassName="active"
          partiallyActive={true}
        >
          AI 아카이브
        </StyledLink>
        {/* <Link className="under" to="/">
          포트폴리오
        </Link> */}

        {/* <Icons>
          <ThemeToggler>
            {({ theme, toggleTheme }) => (
              <Icon>
                <Dark
                  onClick={() => {
                    dispatch(changeTheme(theme === "dark" ? "light" : "dark"));
                    toggleTheme(theme === "dark" ? "light" : "dark");
                  }}
                >
                  {theme === "dark" ? (
                    <FontAwesomeIcon icon={faSun} />
                  ) : (
                    <FontAwesomeIcon icon={faMoon} />
                  )}
                </Dark>
              </Icon>
            )}
          </ThemeToggler>
        </Icons> */}
      </Buttons>
    </Container>
  );
};

export default Header;
